import React from 'react'
import { Typography } from '@ann/web-components'
import { CompanyDriveContainer, CompanyDriveContent } from './CompanyDrivePage.styled'

const CompanyDrivePage = () => {
    return (
        <CompanyDriveContainer>
            <CompanyDriveContent>
                    Contenido de Company Drive
            </CompanyDriveContent>
        </CompanyDriveContainer>
    )
}

export default CompanyDrivePage
